import Vue from 'vue'
import microApps from '@/config/microApps.config'
import { querySystemExtListForSub } from '@/api/index'
import { getServiceCurrentDomainDetail } from '@/api/sso/role'
import { queryPageTypeList } from '@/api/sso/pageTypeInfo'
import { ACCESS_TOKEN, CLUSTER_PREFIX } from '@/store/mutation-types'

const permission = {
  state: {
    microApps: [...microApps],
    systems: [],
    proxy: {
      // 'amazon': 'http://localhost:9001',
      // 'dms-web': 'http://localhost:1080',
      // 'scm-web': 'http://localhost:8085',
      // 'fms': 'http://localhost:8091',
      // 'am_vc': 'http://localhost:9003',
      // 'xproject': 'http://localhost:8888',
      // 'scm_new': 'http://localhost:5173',
      // 'warehouse_system': 'http://127.0.0.1:9900'
      // 'scm_new': 'http://localhost:5173'
      // 'order_system': 'http://localhost:8866'
    }
  },
  mutations: {
    SET_MICRO_APPS: (state, apps) => {
      state.microApps = apps
    },
    SET_SYSTEMS: (state, systems) => {
      state.systems = systems
    }
  },
  actions: {
    InitMicroAppsEntry ({ state, commit }, params) {
      return getServiceCurrentDomainDetail({ ...params, systemCode: undefined })
      .then(async (res) => {
        const { serviceCurrentDomainDTOList } = res.data
        const apps = [
          ...microApps,
          ...serviceCurrentDomainDTOList
            .map(({ domain, middlePath: name, ...other }) => {
              const entry = location.port && state.proxy[name]
              ? state.proxy[name]
              : /^http:\/\//.test(domain)
                ? domain.replace('http://', window.location.protocol + '//')
                : domain
              return { entry, name, ...other }
            })
        ]
        commit('SET_MICRO_APPS', apps)
        // 获取页面类型
        // let isERP = apps.find(item => item.systemCode === 'ORDER_MANAGER' && item.subTab === 7)
        let pageTypeId
        if (params.systemCode === 'ERP') {
          const { data } = await queryPageTypeList({ paging: false, systemCode: params.systemCode, serviceId: params.serviceId })
          pageTypeId = (data || []).find(item => item.selectFlag === 2)?.id
        }
        return { microApps: apps, pageTypeId }
      })
      .then(res => {
        const preloadAppsSystemCode = ['SCM_NEW', 'ORDER_SYSTEM', 'AMAZON_OPERATE']
        const preloadApps = []

        res?.microApps?.forEach(item => {
          if (preloadAppsSystemCode.includes(item.systemCode)) preloadApps.push({ systemCode: item.systemCode, entry: item.entry })
        })
        preloadApps.forEach((item) => {
            fetch(`${item.entry}`)
              .then((response) => response.text())
              .then((html) => {
                if (preloadAppsSystemCode.includes(item.systemCode)) {
                  const regex = /<script>const preloadBundles=\['(.*?)'\];<\/script>/
                  const matches = String(html).match(regex)
                  const links = matches?.[1]
                    ? String(matches[1])
                        .split("','")
                        .map((link) => `${String(item.entry).endsWith('/') ? item.entry : `${item.entry}/`}${String(link).startsWith('/') ? link.slice(1) : link}`)
                    : []
                    // 创建新的 <link> 标签并预加载
                  links.forEach((link) => {
                    if (link.endsWith('css')) return
                    const newLink = document.createElement('link')
                    newLink.rel = link.endsWith('js') ? 'modulepreload' : 'stylesheet'
                    newLink.href = link
                    document.head.appendChild(newLink)
                  })
                }
              })
          })
        return res
      })
    },
    QuerySystemExtListForSub ({ commit, state, rootState }, reset = false) {
      return new Promise((resolve, reject) => {
        if (state.systems?.length && !reset) return resolve()
        querySystemExtListForSub({
          paging: false,
          serviceCode: 'ERP+',
          fromFrontPage: true
        }).then(({ dataList }) => {
          const systems = (dataList?.[0]?.serviceInfoExt || [])
            .filter(item => item.systemCode === 'SELMUCH_ADS' ? rootState.showYST : true)
            .map((item) => {
              if (item.systemName === 'Amazon 运营') {
                item.systemName = '运营'
              } else if (item.systemCode === 'ERP' && item[CLUSTER_PREFIX]) {
                Vue.ls.set(CLUSTER_PREFIX, item[CLUSTER_PREFIX])
              }
              return item
            })
          commit('SET_SYSTEMS', systems)
          resolve()
        })
      })
    },

    async toSystem ({ state }, { system, vm }) {
      console.log('system, vm', system, vm)
      const { systemCode } = system
      const token = vm.$ls.get(ACCESS_TOKEN)
      let found = state.systems.find(item => item.systemCode === systemCode)
      if (!found) {
        if (systemCode === 'SELMUCH_ADS') {
          vm.$winOpen('/#/company/serve/buy-serve?systemCode=SELMUCH_ADS', '_blank')
        }
        return
      }
      // 系统状态1:初始化2:正常3:停用4:过期9:废弃
      if (found.status === 3) {
        vm.$message.warning('当前系统已停用，不支持查看，请联系您的专属销售经理处理')
      } else if (found.status === 9) {
        vm.$message.warning('当前系统已废弃，不支持查看，请联系您的专属销售经理处理')
      } else if (found.serviceDeploy <= 2) {
        vm.$message.warning('当前系统正在部署中，不支持查看')
      } else if (found.embedded === 2) {
        let url = `${found.systemDomain}?token=${token}&resource=sso`
        if (/^(http|https)/.test(url) === false) {
          url = `//${url}`
        }
        window.open(url)
      } else {
        window.open(`/entry/${vm.serviceId}/${systemCode}`)
      }
    }
  }
}

export default permission
